import React from "react";
import ReactDOM from "react-dom";
import App from "src/App/App";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
